// @flow
import * as React from "react"
import * as Util from "../common"
import {CardText} from "material-ui/Card"
import {Toolbar, ToolbarGroup, ToolbarTitle} from "material-ui/Toolbar"

const M = Util.intlMessages("view.Privacy")

export default function PrivacyView() {
  return (
    <article>
      <Toolbar>
        <ToolbarGroup>
          <ToolbarTitle text={<M id="title" />} />
        </ToolbarGroup>
      </Toolbar>
      <CardText>
        <p>
          We collect your email address during registration. We'll send you mail
          only when you ask us to recover a lost password. We share your email
          address only with the{" "}
          <a
            href="https://firebase.google.com/docs/auth/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Firebase Authentication service
          </a>{" "}
          to register and sign in to your account; no other third-parties.
        </p>
        <p>
          We collect your password during registration. Please don't reuse a
          password you've used for any other websites/apps/games. (<a
            href="https://www.lastpass.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Lastpass
          </a>{" "}
          is a good way to avoid reusing passwords.)
        </p>
        <p>
          You can play without sharing your email address with us! Feel free to
          do that, or to use a fake email like{" "}
          <a
            href="https://www.spamgourmet.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Spamgourmet
          </a>, or to ask us to delete your email/password from our records.
        </p>
        <p>&nbsp;</p>
        <p>
          We store cookies to remember which account and characters you're
          playing when you visit our site. Click "log out" on the title screen
          to remove these cookies.
        </p>
        <p>
          We use{" "}
          <a
            href="https://www.google.com/analytics/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Google Analytics
          </a>{" "}
          to collect information about actions you take on our website, like
          links you've clicked, in order to improve gameplay. Feel free to{" "}
          <a
            href="https://tools.google.com/dlpage/gaoptout"
            target="_blank"
            rel="noopener noreferrer"
          >
            opt out of Google Analytics
          </a>{" "}
          for War Swarms and for all other websites.
        </p>
        <p>
          We use Google's{" "}
          <a
            href="https://firebase.google.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Firebase
          </a>{" "}
          to store your saved progress and to run gameplay processes.
        </p>
        <p>
          <a
            href="http://www.google.com/policies/privacy/partners/"
            target="_blank"
            rel="noopener noreferrer"
          >
            How Google uses data when you use our partners' sites or apps
          </a>
        </p>
        <p>&nbsp;</p>
        <p>
          I'm generally happy to talk through any privacy issues you might have.
          Feel free to reach out.
        </p>
        <p>War Swarms is not a wealthy target. Please don't sue.</p>
        <p>Thanks for reading!</p>
        <small>
          <time dateTime="2017-09-29" itemProp="datePublished">
            2017-09-29
          </time>
        </small>
      </CardText>
    </article>
  )
}



// WEBPACK FOOTER //
// ./src/app/PrivacyView.js